import styled, { css } from 'styled-components'

export const CheckboxContainer = styled.div`
  ${({ display, gap, wrap }) => css`
    display: ${display || 'unset'};
    gap: ${gap || 'unset'};
    flex-wrap: ${wrap ? 'wrap' : 'unset'};
  `}
`

export const TextTermsAndConditions = styled.p`
  margin-left: 2em;
  cursor: pointer;
`
